// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mg-0";